<template>
    <div>
      <navbar :title="text"></navbar>
      <div class="container">
        <van-cell-group>
            <van-cell  title="头像" center>
                <van-image v-show="imgshowa == 1 " slot="default" width="50px" height="50px" fit="cover" round :src="this.userInfo.avatar" />
                <van-image v-show="imgshowa == 2 " slot="default" width="50px" height="50px" fit="cover" round src="http://rjwpublic.oss-cn-qingdao.aliyuncs.com/album/space/dynamic1592536362816.jpg" />
                <van-uploader :multiple="true" :preview-full-image="true" :after-read="afterRead" :max-count="1"/>
            </van-cell>
            <van-cell @click="nameclick" is-link title="昵称" :value="this.item.user_nicename" />
            <van-cell @click="sexclick" is-link title="性别" :value="this.sextitle" />
            <van-cell @click="qianming" is-link title="签名" :value="this.item.signature" />
        </van-cell-group>
      </div>
      <!-- 性别弹层 -->
      <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }">
        <div class="tanchu" >
          <div  v-for="sexList in sexlist" v-bind:key="sexList.name" @click="sexclicked(sexList)">{{sexList.name}}</div>
        </div>
        <div class="falsebtn" @click="falsebtn">取消</div>
      </van-popup>

      <div>
        <van-button class="tuichubtn" round type="info" @click="exit">注销账号</van-button>
      </div>
    </div>
</template>

<script>
import URL from '../../api/index'
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';
import { Image } from 'vant';
import { Toast } from 'vant';
import { Popup } from 'vant';
import { Picker } from 'vant';
import { Uploader } from 'vant';
import { ActionSheet } from 'vant';
import $ from 'jquery'
Vue.use(ActionSheet);
Vue.use(Uploader);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Toast);
Vue.use(Image);
Vue.use(Cell);
Vue.use(CellGroup);
import navbar from '../../components/Navbar'
export default {
    components:{
        navbar
    },
  data(){
    return{
      text:'个人资料',
      fileList: [],
      userInfo:'',
      item:'',
      leaveimg: false,
      show: false,
      sexcheck:'-1',
      imgshow:'',
      imgshowa:'1',
      sexlist:[
        {name:'男',value:'1'},
        {name:'女',value:'2'},
        {name:'保密',value:'3'},
      ],
      sextitle:'',
      uploadimglist:[],
    }
  },
  mounted() {
    if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
    }
    this.getuser();
    this.getOssToken()
  },
  methods:{
    //退出
    exit () {
      var identity = localStorage.getItem('identity')
      localStorage.clear()
      localStorage.setItem('identity',identity)
      this.$router.push({path:'/'})
    },
    //  获取用户信息 api.rujiaowang.net/api/user/get_user
    getuser(){
        this.$http.post('api/user/get_user',
          {
            token: this.userInfo.token
          }
        )
        .then( item => {
          this.item = item.data.result
          this.imgshow = this.item.avatar
          if( this.imgshow == "" || this.imgshow == " " ){
            this.imgshowa = 2
          }else{
            this.imgshowa = 1
          }
          if( this.item.sex == '1' ){
            this.sextitle = "男"
          }else if( this.item.sex == "2" ){
            this.sextitle = "女"
          }else if( this.item.sex == "3" ){
            this.sextitle = "保密"
          }
        })
    },
    nameclick(){
      this.$router.push({path:'/altername'})
    },
    falsebtn(){
      this.show = false
    },
    afterRead(file) {
      this.uploadimg = file.file
      this.upload()
      console.log(this.uploadimg)
    },
    //获取上传通行证
    getOssToken(){
        var _self = this;
        this.$http.get('http://api.rujiaowang.net/api/all/avatar_get_oss_key').then(function(res){
        // console.log(res)
            if(res.status == 200){
                _self.aliyunOssToken = res.data;
                // console.log(_self.aliyunOssToken)
            }else{
                _self.$message.error(res.data.message);
            }
        }).catch(function(error){
        // console.log(error);
        })
    },

    upload(){//上传相册 
        var _self = this;
        var onefile = this.uploadimg
        var filename = onefile.name;
        var getSuffix = function (filename) {
          var pos = filename.lastIndexOf(".");
          var suffix = '';
          if (pos != -1) {
              suffix = filename.substring(pos);
          }
          return suffix;
        }
        // var filenamelist = file.name
        filename = new Date().getTime() +  Math.ceil(Math.random()*10000) + getSuffix(filename);
        var formData = new FormData();
        //注意formData里append添加的键的大小写
        console.log(_self.aliyunOssToken);
        
        formData.append('key', _self.aliyunOssToken.dir + filename); //存储在oss的文件路径

        formData.append('OSSAccessKeyId', _self.aliyunOssToken.accessid); //accessKeyId
        formData.append('policy', _self.aliyunOssToken.policy); //policy
        formData.append('Signature', _self.aliyunOssToken.signature); //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
        formData.append('callback', _self.aliyunOssToken.callback); //policy
        formData.append("file", onefile);
        
        formData.append('success_action_status', 200); //成功后返回的操作码
        var url = _self.aliyunOssToken.host;
        // var fileUrl = _self.aliyunOssToken.host + '/user/avatar/' + _self.aliyunOssToken.dir + filename;

          var point = this; 
          $.ajax({
              url: url,
              type: 'POST',
              data: formData,
              // async: false,
              cache: false,
              contentType: false,
              processData: false,
              success: function (data) { 
                  var dataimg =  data.filename//上传图片链接
                  // contentimg.push(//把链接存入数组
                  //     dataimg
                  // )
                  // console.log(contentimg)
                  point.update_avatar(dataimg)
              },
              error: function (data) {
              }
          });  
          // this.contentimg = contentimg;
    },
    sexclick(){
      this.show = true
    },
    sexclicked(sexcheck){
      console.log(sexcheck.name,sexcheck.value)
      this.sexcheck = -1;
       this.$http.post('api/user/alterme',
        {
          token: this.userInfo.token,
          nicename: this.item.user_nicename,
          sex: sexcheck.value,
        }
      )
      .then( name => {
          this.name = name.data.msg
          Toast(this.name);
          this.getuser();
          this.show = false
      })
    },
    qianming(){
      this.$router.push({path:'/qianming'})
    },
    update_avatar(a){
      console.log(a);
      
      this.$axios({
        method:'post',
        url:URL.update_avatar,
        data:{
            token: this.userInfo.token,
            avatar_name: a
        }
        }).then((res)=>{
            console.log(res);
            this.userInfo.avatar = a
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo))
      })
    }


  },
}
</script>

<style scoped>
.container{
    margin: 10px 0;
}
.van-uploader /deep/ {
    position: fixed;
    top: 55px;
    right: -8px;
    display: inline-block;
    z-index: 2;
    opacity: 0;
}
.tuichubtn:first-child{
  width: 90%;
  display: block;
  margin: 15px auto;
}
.tuichubtn:last-child{
  width: 90%;
  display: block;
  margin: 15px auto  50px;
}
.tanchu div {
    line-height: 45px;
    border: 1px solid #f2f2f2;
    text-align: center;
    font-size: 16px;
}
.falsebtn {
    text-align: center;
    width: 100%;
    line-height: 45px;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #FFF;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/userData/userData.vue